<template>
	<div class="u-container">
		<CheckPassword
			v-if="!step || step === 1"
			@changeStep="changeStep"
		></CheckPassword>
		<UserLeaveForm v-if="step === 2"></UserLeaveForm>
	</div>
</template>

<script>
import CheckPassword from '@/components/CheckPassword';
import UserLeaveForm from '@/components/UserLeaveForm';

export default {
	components: {
		CheckPassword,
		UserLeaveForm,
	},
	data() {
		return {
			step: 1,
		};
	},
	methods: {
		changeStep(step) {
			this.step = step;
		},
	},
};
</script>
